import { Model } from "@interfaces/model.interface";

export interface CrmContact extends Model {
	christmasGift: boolean;
	christmasGiftNotes?: string;
	clientId: number;
	crmLeadId: number;
	email: string;
	firstName: string;
	isActive: boolean;
	isSensitive: boolean;
	jobTitle: string;
	lastName: string;
	notes: string;
	phone: string;
}

export class CrmContact implements CrmContact {

	constructor(data?: Partial<CrmContact>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}
